export default function isEmpty(array: { length: number }) {
  return array.length < 1;
}
